import axios from 'axios';

let isMovingGroup = false;
let isMovingBlock = false;
let isRecalcingOrder = false;

export async function login2(values) {
  axios.defaults.withCredentials = true;
  const res = await axios.post('/login2', values);

  const login = res.data.Login;
  return login;
}

export async function sessionCheck(values) {
  axios.defaults.withCredentials = true;
  const res = await axios.get('/session-check');

  const check = res.data;
  return check;
}

export async function logout() {
  axios.defaults.withCredentials = true;
  const response = await axios.post(`/logout`);
  return response;
}

export async function verificationCode(values) {
  axios.defaults.withCredentials = true;
  await axios.post('/verificationcode', values);
}

export async function verify(values) {
  axios.defaults.withCredentials = true;
  const res = await axios.post('/verify', values);

  const verify = res.data.Verified;
  return verify;
}

export async function newPassword(values) {
  axios.defaults.withCredentials = true;
  const res = await axios.post('/newpassword', values);

  const passwordChanged = res.data.PasswordChanged;
  return passwordChanged;
}

export async function newEmailAndPassword(values) {
  axios.defaults.withCredentials = true;
  const res = await axios.post('/newemailandpassword', values);

  const changed = res.data.Changed;
  return changed;
}

export async function pfpOrderPageSkin(id) {
  const response = await axios.get(`/pfporderpageskin/${id}`);
  const data = response.data;
  return data;
}

export async function createUser(input) {
    const res = await axios.post('/createuser', input, {
        withCredentials: true
    });

    return res.data;
}

export async function getUser(id) {
    axios.defaults.withCredentials = true;
    const res = await axios.get(`/getuser/${id}`);
    return(res.data);
}

export async function getPendingUsers() {
  axios.defaults.withCredentials = true;
    const res = await axios.get(`/getpendingusers`);
    return(res.data);
}

export async function getPageContent(pageCode) {
  axios.defaults.withCredentials = true;
  const res = await axios.get(`/getpage/${pageCode}`);
  return(res.data);
}

export async function getProfileContent(userId) {
  axios.defaults.withCredentials = true;
  const res = await axios.get(`/getprofile/${userId}`);
  return(res.data);
}

export async function getSearchContent(q, p, f, s) {
  axios.defaults.withCredentials = true;
  const res = await axios.get(`/getsearch?q=${encodeURIComponent(q)}&p=${p}&f=${f}&s=${s}`);
  return res.data;
}

export async function getGroupContent(groupLink) {
  axios.defaults.withCredentials = true;
  const res = await axios.get(`/getgroup/${groupLink}`);
  return(res.data);
}

export async function getManagerContent(userId) {
  axios.defaults.withCredentials = true;
  const res = await axios.get(`/getmanagercontent/${userId}`);
  return(res.data);
}

export async function getUserManager() {
  axios.defaults.withCredentials = true;
  const res = await axios.get(`/getusermanager`);
  return(res.data);
}

export async function updateUsers(users) {
  axios.defaults.withCredentials = true;
  await axios.patch('/updateusers', users);
}

export async function getPeople(userId) {
  axios.defaults.withCredentials = true;
  const res = await axios.get(`/getpeople/${userId}`);
  return(res.data);
}

export async function blockUser(blockerId, blockedId) {
  const values = {blockerId, blockedId};
  axios.defaults.withCredentials = true;
  await axios.post('/block-user', values);
}

export async function unblockUser(unblockerId, unblockedId) {
  axios.defaults.withCredentials = true;
  await axios.delete(`/unblock-user`, {
    params: { unblockerId, unblockedId }
  });
}

export async function getBlockCheck(user1, user2) {
  axios.defaults.withCredentials = true;
  const res = await axios.get(`/getblockcheck/${user1}/${user2}`);
  return(res.data);
}

export async function addBlockToDB(groupId, pageId, order, type, retract, columnStart, columnEnd, title, content) {
  const values = {groupId, pageId, order, type, retract, columnStart, columnEnd, title, content}

  axios.defaults.withCredentials = true;
  const res = await axios.post('/createblock', values);

  if (res.status === 200) {
    const { blockId } = res.data;  // Capture the returned blockId
    return blockId;  // Return the blockId to the caller
  }

  return null;
}

export async function upload(formData) {
    const response = await axios.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
}

export async function addGroupToDB(pageId, newGroup) {

  const values = {pageId, groupOrder: newGroup.order, groupTitle: newGroup.title, 
    ...(newGroup.blocks[0] && {blockOrder: newGroup.blocks[0].order, blockType: newGroup.blocks[0].type, blockRetract: newGroup.blocks[0].retract, 
      blockTitle: newGroup.blocks[0].title, blockColumnStart: newGroup.blocks[0].columnStart, 
      blockColumnEnd: newGroup.blocks[0].columnEnd, content: newGroup.blocks[0].content})
  }

  axios.defaults.withCredentials = true;
  const res = await axios.post('/creategroup', values);

  if (res.status === 200) {
    const { groupId, blockId } = res.data;
    newGroup.id = groupId;
    if (newGroup.blocks.length > 0) {
      newGroup.blocks[0].id = blockId;
    }
  }

  return res.status;
}

export async function editGroupOnDB(groupId, newGroupTitle) {
  const values = {groupId, newGroupTitle};
  axios.defaults.withCredentials = true;
  await axios.patch('/editgroup', values);
}

export async function editBlockOnDB(id, newType, newRetract, newTitle, newContent) {
  const values = {id, newType, newRetract, newTitle, newContent};
  axios.defaults.withCredentials = true;
  await axios.patch('/editblock', values);
}

export async function deleteGroupFromDB(pageId, groupId, groupOrder) {
  axios.defaults.withCredentials = true;
  await axios.delete(`/deletegroup`, {
    params: { pageId, groupId, groupOrder }
  });
}

export async function deleteBlockFromDB(groupId, blockId, blockOrder) {
  axios.defaults.withCredentials = true;
  await axios.delete(`/deleteblock`, {
    params: { groupId, blockId, blockOrder }
  });
}

export async function moveGroupInDB(pageId, groupOrder, destination, groupCount) {
  if (isMovingGroup) return; // Prevent second call
  isMovingGroup = true;

  try {
    const values = { pageId, groupOrder, destination, groupCount }
    axios.defaults.withCredentials = true;
    await axios.patch(`/movegroup`, values);
  } finally {
    isMovingGroup = false;
  }
}

export async function moveBlockInDB(groupId, blockOrder, desiredOrder, blockCount, newColumnStart, newColumnEnd) {
  if (isMovingBlock) return; // Prevent second call
  isMovingBlock = true;

  try {
    const values = { groupId, blockOrder, desiredOrder, blockCount, newColumnStart, newColumnEnd }
    axios.defaults.withCredentials = true;
    await axios.patch(`/moveblock`, values);
  } finally {
    isMovingBlock = false;
  }
}

export async function updateBlockWidthInDB(id, newColumnStart, newColumnEnd) {
  const values = { id, newColumnStart, newColumnEnd }
  axios.defaults.withCredentials = true;
  await axios.patch(`/blockwidth`, values);
}

export async function updateBlockOrderInDB(groupId, finalPlacements, blockCount) {
  if (isRecalcingOrder) return;
  isRecalcingOrder = true

  try {
    const values = { groupId, finalPlacements, blockCount }
    axios.defaults.withCredentials = true;
    await axios.patch(`/reorder`, values);
  } finally {
    isRecalcingOrder = false;
  }
}

export async function createNew(newItem, author) {
  const values = {
    authorId: author, 
    newItem
  }
  axios.defaults.withCredentials = true;
  let res;
  if (newItem.type === "page" || newItem.type === "folder") {
    res = await axios.post('/createnew', values); 
  } else {
    res = await axios.post('/createnewskin', values); 
  }

  if (res.status === 200) {
    const { itemId, randomCode } = res.data;  // Capture the returned blockId
    return { itemId, randomCode };  // Return the blockId to the caller
  }
}

export async function regenURL(id) {
  const values = {id}
  axios.defaults.withCredentials = true;
  const res = await axios.patch('/regenurl', values);

  if (res.status === 200) {
    const { randomCode } = res.data;  // Capture the returned blockId
    return { randomCode };  // Return the blockId to the caller
  }
}

export async function createGroupLink(id) {
  const values = {id}
  axios.defaults.withCredentials = true;
  const res = await axios.patch('/creategrouplink', values);

  if (res.status === 200) {
    const { newLink } = res.data;  // Capture the returned blockId
    return { newLink };  // Return the blockId to the caller
  }
}

export async function breakGroupLink(id) {
  const params = {id}
  axios.defaults.withCredentials = true;
  await axios.delete('/breakgrouplink', {params});
}

export async function deleteItemFromDB(type, id, order, parentId, authorId, defaultId) {
  axios.defaults.withCredentials = true;
  await axios.delete(`/deleteitem`, {
    params: { type, id, order, parentId, authorId, defaultId }
  });
}

export async function editItemOnDB(newItem) {
  const values = {newItem};
  axios.defaults.withCredentials = true;
  await axios.patch('/edititem', values);
}

export async function moveItemInDB(authorId, id, type, oldOrder, newOrder, newParentId) {
  const values = {authorId, id, type, oldOrder, newOrder, newParentId};
  axios.defaults.withCredentials = true;
  await axios.patch('/moveitem', values);
}

export async function rearrangeItemsInDB(authorId, itemId, itemType, itemOldOrder, itemDesiredOrder) {
  const values = {authorId, itemId, itemType, itemOldOrder, itemDesiredOrder};
  axios.defaults.withCredentials = true;
  await axios.patch('/rearrangeitems', values);
}

export async function createNewSkin(newItem, author) {
  const values = {
    authorId: author, 
    order: newItem.order,
    title: newItem.title, 
    groupWidth: newItem.groupWidth,
    columnStart: newItem.columnStart,
    columnEnd: newItem.columnEnd,
    pageTitleFont: newItem.pageTitleFont, 
    pageTitleColor:newItem.pageTitleColor, 
    pageSubtitleFont: newItem.pageSubtitleFont,
    pageSubtitleColor: newItem.pageSubtitleColor, 
    pageBackgroundColor: newItem.pageBackgroundColor,
    backgroundImage: newItem.backgroundImage,
    curvedBorders: newItem.curvedBorders, 
    groupBorders: newItem.groupBorders, 
    blockBorders: newItem.blockBorders, 
    borderColor: newItem.borderColor, 
    titleBorderColor: newItem.titleBorderColor, 
    groupBackgroundColor: newItem.groupBackgroundColor,
    blockBackgroundColor: newItem.blockBackgroundColor, 
    textFont: newItem.textFont, 
    textSize: newItem.textSize, 
    textColor: newItem.textColor, 
    linkColor: newItem.linkColor, 
    linkHoverColor: newItem.linkHoverColor 
  }
  axios.defaults.withCredentials = true;
  const res = await axios.post('/createnewskin', values);

  if (res.status === 200) {
    const { skinId } = res.data;  // Capture the returned blockId
    return skinId;  // Return the blockId to the caller
  }
}

export async function editUserDetails(userId, newItem) {
  const values = {
    userId: userId,
    username: newItem.username,
    pfp: newItem.pfp, 
    group_order: newItem.group_order, 
    highlight_colors: JSON.stringify(newItem.highlight_colors),
    page_colors: JSON.stringify(newItem.page_colors)
  };
  axios.defaults.withCredentials = true;
  await axios.patch('/edituser', values);
}

export async function userPaid(userId) {
  const values = {userId: userId,};
  axios.defaults.withCredentials = true;
  await axios.patch('/userpaid', values);
}

export function initialisePageSkins(skin) { //currently doesn't do: backgroundImage, borderColor (both have been done elsewhere)
  const styleElement = document.createElement('style');
  styleElement.innerHTML = `
    body {
      background-color: ${skin.pageBackgroundColor};
    }
    .actual-creator-pfp {
      border-radius: ${skin.curvedBorders === 1? "20px": "0"};
    }
    .page-title h2 {
      font-family: ${skin.pageTitleFont}, Times New Roman;
      color: ${skin.pageTitleColor};
      font-weight: ${skin.pageTitleFont === "Source Code Pro" ? "300;" : "700"};
    }
    h3 {
      font-family: ${skin.pageSubtitleFont}, Times New Roman;
      color: ${skin.pageSubtitleColor};
      ${skin.pageTitleFont === "Source Code Pro" && "font-weight: 300;"}
    }

    .page-title h3 a:hover, .a-sub:hover {
      color: ${skin.linkHoverColor};
    }
    .page-nav-main div, .link-menu {
      border-radius: ${skin.curvedBorders === 1? "5px": "0"};
      border: 1px solid ${skin.borderColor};
      font-family: ${skin.pageSubtitleFont}, Times New Roman;
    }
    .page-nav-main div, .page-nav-option {
      color: ${skin.pageSubtitleColor};
    }
    .page-nav-option-container {
      border-radius: ${skin.curvedBorders === 1? "5px": "0"};
    }
    .page-nav-option {
      font-family: ${skin.pageSubtitleFont}, Times New Roman;
    }
    .page-nav-option, .link-menu {
      background-color: ${( skin.backgroundImage? "rgba(0, 0, 0, 0)" : 
        skin.pageBackgroundColor !== "rgba(0, 0, 0, 0)" && skin.pageBackgroundColor !== "#00000000") ? 
        skin.pageBackgroundColor : "rgb(242, 244, 248)" };
    }
    .page-nav-button {
      color: ${skin.pageSubtitleColor};
    }
    .block-title-border-block {
      border-bottom: 1px solid ${skin.titleBorderColor};
    }
    .border-block {
      border-radius: ${skin.curvedBorders === 1? "10px": "0"};
    }
    .group, .time-created {
      background-color: ${skin.groupBackgroundColor};
      border-radius: ${skin.curvedBorders === 1? "10px": "0"};
    }
    .border-block {
      background-color: ${skin.blockBackgroundColor};
    }
    p, h4, h5, li, .folder-block-item > *, .folder-block-item, .time-created {
      font-family: ${skin.textFont}, Times New Roman;
      font-size: ${skin.textSize}px;
      color: ${skin.textColor};
    }
    p a, .folder-block-item > *, .folder-block-item {
      color: ${skin.linkColor};
    }
    p a:hover, .folder-block-item:hover > *, .folder-block-item:hover {
      color: ${skin.linkHoverColor};
    }
    h4 {
      font-size: ${skin.textSize + 4}px
    }
    h5 {
      font-size: ${skin.textSize + 2}px
    }
    .time-created {
      font-size: ${skin.textSize}px
    }

    .block-edit-buttons button, .group-edit-buttons button {
      border-radius: ${skin.curvedBorders === 1? "5px": "0"};
      color: ${skin.textColor};
      border: 1px solid ${skin.borderColor};
    }
    .retract-div {
    color: ${skin.textColor};
    }
  `;
  document.head.appendChild(styleElement);
  return () => {
    document.head.removeChild(styleElement);
  };
}

export async function initialiseBaseSkins(userId) {
  axios.defaults.withCredentials = true;
  const res = await axios.get(`/getuser/${userId}`);
  const skin = JSON.parse(res.data.pageColors.replace(/'/g, '"'))
  const styleElement = document.createElement('style');
  styleElement.innerHTML = `
    body {
      background-color: ${skin[1]};
    }
    
    h2, h3, h4, h5, p {
      color: ${skin[4]};
    }

    .group {
      background-color: rgba(0, 0, 0, 0)
    }
  `;
  document.head.appendChild(styleElement);
  return () => {
    document.head.removeChild(styleElement);
  };
}

export function initialiseUserSkin(skin) {
  const styleElement = document.createElement('style');
  styleElement.innerHTML = `
    .folder-checkbox input:checked ~ .checkmark {
      background-color: ${skin[0]};
    }
    h1, .search-filter-container *, .creator-pfp, #error-notice, .settings-title .title-text, .settings-title h3, .notice a{
      color: ${skin[0]};
    }
    header, .header-menu > *:hover, .notice, #create-container, #close-confirm,
    #folder-toolbar, #folder-create-container, .folder-navigator button:hover,
    .reordering-block, .people-item, .folders-item, .people-menu,
    #colors-add-row, .button, .radio-container:hover input ~ .radio, .radio {
      background-color: ${skin[1]};
    }
    .people-item-default-image, #arrow, .actual-creator-pfp {
      color: ${skin[1]};
    }
    .options-nav{
      border-bottom: 3px solid ${skin[1]};
    }
    #create-block input, #create-block button, #create-block select, .block-type-option, #text-editor, .folder-actions *:hover, #reordering, #folder-create > *,
    #skin-create label input[type="text"], #skin-create label select, #folder-submit-button, input[name="title"], .checkmark, .settings-button, 
    #skin-create label input[type="password"], #folders-display-notice div, .folders-item-menu > div,
     .search-container button:hover, .settings-file-upload {
      background-color: ${skin[2]};
    }
    .search-container > *, #options-container, .header-menu, .actual-creator-pfp, .block-type-option:hover, #submit-button:hover, #block-type-selected, .button:hover,
    .folder-navigator, .settings-button:hover, .settings-file-upload:hover, #folder-submit-button:hover, #folders-display-notice div:hover, .folders-item:hover, #folders-item-selected,
    .people-item-content:hover, .people-item-image, #colors-add-row:hover, .folder-actions *, .people-menu:hover {
      background-color: ${skin[3]};
    }
    .folder-actions *, #folders-display-notice div {
      border: 1px solid ${skin[3]};
    }
    .header-icon, #pfp, .folder-button:hover {
      color: ${skin[3]};
    }
    .search-container button svg, .search-container input[type=text]::placeholder, .header-menu > *, .folder-explore-tools, .folder-actions *, .button, 
    #skin-id-select *, #folders-display-notice *, .folders-item-footer *, .folder-navigator button {
      color: ${skin[4]};
    }
    .menu-icon, #create-area-options *, .button * {
      fill: ${skin[4]};
    }
    .creator-pfp, .folders-item-menu > div:hover {
      background-color: ${skin[1]};
    }
    #colors-display input {
      background-color: ${skin[1]} !important;
    }
    .search-container :focus, .search-container input[type=text]:focus::placeholder, .search-container input[type=text]:hover::placeholder,
    .search-container button:hover svg, .search-container input[type=text]::placeholder:hover, #people:hover, #arrow:hover, .header-menu > *:hover, .page-nav-option:hover, .nav-current-page,
     .button:hover, .settings-button:hover, .settings-file-upload:hover, #folder-submit-button:hover, #folders-display-notice div:hover,
    .folders-item-header:hover *, .folders-item-selected *, .people-item-content:hover *, #colors-add-row:hover, .settings-file-upload:hover,
    .block-type-option:hover, #submit-button:hover {
      color: ${skin[1]};
    }
    .block-type-option:hover, #submit-button:hover, .button:hover * {
      fill: ${skin[1]};
    }
    #pfp:hover {
      outline: 1px solid ${skin[1]};
    }
    .radio-container .radio:after {
      background: ${skin[1]};
    }
    #create-block input, #create-block button, #create-block select, #text-editor, #close-confirm h2, .options-nav *:hover,
    .folder-navigator, #folder-create > *, #skin-create > * > * > *, #skin-create label input[type="text"], #skin-create label select, #folder-submit-button, 
    input[name="title"], #skin-create .folder-checkbox, .settings-button, #skin-create label input[type="password"], .manager-create-close, #folders-display-notice,
    .folders-item-header *, .folders-item-footer, .folders-item-menu > div, .people-item *, .settings-file-upload, .radio-container,
    .block-type-option, #create-block input::placeholder, #youtube-search-container button, .folders-item-options:hover, .search-container > *, #skin-create p, .notice {
      color: ${skin[4]};
    }
    .radio-container input:checked ~ .radio {
      background-color: ${skin[4]};
    }
    .locator {
      background-color: ${skin[0]};
    }
  `;
  document.head.appendChild(styleElement);
  return () => {
    document.head.removeChild(styleElement);
  };
}